module.exports = __webpack_public_path__ + "static/media/project-image-9.d099cde9.jpg";